import { Injectable } from "@angular/core";
import { FetchStatusSelector, FetchStatusType } from "@obg/ngrx-utils";
import { AppContextSelector } from "@obg/ngx.core";
import { isBoolean } from "lodash-es";
import { Observable } from "rxjs";
import { distinctUntilChanged, filter, map } from "rxjs/operators";

import { CommonState } from "../state";

import { ACTION_PREFIX, DATA_PROTECTION_ACTION_TYPE } from "./data-protection.action";
import { DataProtectionConfigService } from "./data-protection.config";

@Injectable({
	providedIn: "root",
})
export class DataProtectionSelector {
	constructor(private config: DataProtectionConfigService) {}

	isGdprEnabledForCurrentCountry$() {
		return (state$: Observable<CommonState>): Observable<boolean> =>
			state$.pipe(
				map((state) => {
					const country = AppContextSelector.getCountryCode(state);

					if (this.config.getCookieConsentDisabled()) {
						return false;
					}

					if (!country) {
						return true;
					}

					if (
						!FetchStatusSelector.isStatus(
							DATA_PROTECTION_ACTION_TYPE.getGdprEnabledCountries,
							FetchStatusType.Success
						)(state) &&
						!FetchStatusSelector.isStatus(
							DATA_PROTECTION_ACTION_TYPE.getGdprEnabledCountries,
							FetchStatusType.Fail
						)(state)
					) {
						return undefined;
					}

					if (
						FetchStatusSelector.isStatus(
							DATA_PROTECTION_ACTION_TYPE.getGdprEnabledCountries,
							FetchStatusType.Fail
						)(state)
					) {
						return true;
					}

					return (
						!state.dataProtection.gdprEnabledCountries ||
						state.dataProtection.gdprEnabledCountries.includes(country)
					);
				}),
				distinctUntilChanged(),
				filter(isBoolean)
			);
	}

	isOneTrustEnabledForCurrentCountry$() {
		return (state$: Observable<CommonState>): Observable<boolean> =>
			state$.pipe(
				map((state) => {
					if (this.config.getCookieConsentDisabled()) {
						return false;
					}

					if (this.config.getOneTrustCountryCheckIsSkipped()) {
						return true;
					}

					const country = AppContextSelector.getCountryCode(state);
					return !country || this.config.getOneTrustEnabledCountries().includes(country);
				}),
				distinctUntilChanged(),
				filter(isBoolean)
			);
	}

	isGdprEnabledForCountry(country: string) {
		return (state: CommonState): boolean | undefined =>
			state.dataProtection.gdprEnabledCountries && state.dataProtection.gdprEnabledCountries.includes(country);
	}

	isBusy() {
		return (state: CommonState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	}
}
